import { termsErrorCode } from "@/pages/contracts/components/updateTerms/saveErrorMessage";

// The version was not pending when the withdrawal reached it — applied,
// withdrawn already, or never real.
//
// Deliberately not the correction save's `PENDING_AMENDMENT_WITHDRAWN`, which
// means "the correction you were saving could not proceed" and drives that
// dialog's recovery path (contractsapi `terms/withdrawal.py`).
const VERSION_NOT_PENDING = "VERSION_NOT_PENDING";

export const isWithdrawVersionNotPending = (error: unknown): boolean =>
  termsErrorCode(error) === VERSION_NOT_PENDING;
